"use strict";
// VehicleTypeDTO.ts
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicVehicleBodyTypeDTO = exports.VehicleBodyTypeUpdateDTO = exports.VehicleBodyTypeCreateDTO = exports.VehicleBodyTypeGetUniqueDTO = exports.VehicleBodyTypeGetDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const BaseDTO_1 = require("./BaseDTO");
class VehicleBodyTypeGetDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map(error => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleBodyTypeGetDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleBodyTypeGetDTO = VehicleBodyTypeGetDTO;
class VehicleBodyTypeGetUniqueDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map(error => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleBodyTypeGetUniqueDTO, plain);
    }
    toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleBodyTypeGetUniqueDTO = VehicleBodyTypeGetUniqueDTO;
class VehicleBodyTypeCreateDTO extends BaseDTO_1.BaseCreateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map(error => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleBodyTypeCreateDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleBodyTypeCreateDTO.prototype, "name", void 0);
exports.VehicleBodyTypeCreateDTO = VehicleBodyTypeCreateDTO;
class VehicleBodyTypeUpdateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map(error => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleBodyTypeUpdateDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleBodyTypeUpdateDTO.prototype, "name", void 0);
exports.VehicleBodyTypeUpdateDTO = VehicleBodyTypeUpdateDTO;
class DynamicVehicleBodyTypeDTO {
    validate() {
        if (!this.existingId && !this.new) {
            throw new Error('Either existingId or new details must be provided.');
        }
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(DynamicVehicleBodyTypeDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DynamicVehicleBodyTypeDTO.prototype, "existingId", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => VehicleBodyTypeCreateDTO),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", VehicleBodyTypeCreateDTO)
], DynamicVehicleBodyTypeDTO.prototype, "new", void 0);
exports.DynamicVehicleBodyTypeDTO = DynamicVehicleBodyTypeDTO;
